import React, { useEffect, useMemo, useState } from "react";
import {
  copyText,
  escapeForTsv,
  formatValue,
  getColumns
} from "./tableColumns";

const PAGE_SIZE_OPTIONS = [10, 20, 25, 50];

export default function DataTable({ data, table }) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const columns = useMemo(() => getColumns(table), [table]);
  const totalPages = Math.max(1, Math.ceil(data.length / pageSize));
  const safePage = Math.min(page, totalPages);
  const start = (safePage - 1) * pageSize;
  const visibleRows = data.slice(start, start + pageSize);
  const [copyStatus, setCopyStatus] = useState("");

  const handleCopyTable = async () => {
    try {
      if (!data.length) {
        setCopyStatus("No hay datos para copiar");
        setTimeout(() => setCopyStatus(""), 2000);
        return;
      }

      const headerLine = columns.map((col) => col.label).join("\t");
      const bodyLines = data.map((row) =>
        columns.map((col) => escapeForTsv(row[col.key])).join("\t")
      );

      const tsv = [headerLine, ...bodyLines].join("\n");

      await copyText(tsv);

      setCopyStatus("Tabla copiada");
      setTimeout(() => setCopyStatus(""), 2000);
    } catch {
      setCopyStatus("No se pudo copiar");
      setTimeout(() => setCopyStatus(""), 2500);
    }
  };

  useEffect(() => {
    setPage(1);
  }, [data, table, pageSize]);

  return (
    <section className="table-card">
      <div className="table-toolbar">
        <button className="primary-button" type="button" onClick={handleCopyTable} disabled={!data.length}>
          Copiar tabla
        </button>
        {copyStatus ? <span>{copyStatus}</span> : null}
        <div className="table-meta">
          <strong>{data.length}</strong>
          <span>resultados</span>
        </div>

        <div className="pagination-controls">
          <label className="field small-field">
            <span>Filas</span>
            <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
              {PAGE_SIZE_OPTIONS.map((value) => (
                <option key={value} value={value}>{value}</option>
              ))}
            </select>
          </label>

          <button className="secondary-button" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={safePage <= 1}>
            Anterior
          </button>
          <div className="page-indicator">Página {safePage} / {totalPages}</div>
          <button className="secondary-button" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={safePage >= totalPages}>
            Siguiente
          </button>
        </div>
      </div>

      <div className="table-shell">
        <table>
          <thead>
            <tr>
              {columns.map((column) => <th key={column.key}>{column.label}</th>)}
            </tr>
          </thead>
          <tbody>
            {visibleRows.length ? (
              visibleRows.map((row, index) => (
                <tr key={`${row.NUM_CLI ?? "row"}-${index}`}>
                  {columns.map((column) => (
                    <td key={column.key}>{formatValue(column.key, row[column.key])}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="empty-cell">Sin resultados</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
